var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyebrows1E(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "frame_730px_1_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "eyebrow_x5F_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eyebrow_x5F_1_3_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M380.3,234.6c-0.2-1.7-1.2-4.4,0.1-5.8c1.3-1.3,5.4-1.2,7.2-1.3c5.1-0.5,10-0.7,15.1-0.5c9.2,0.3,18.5,2.6,25.4,8.8 c1,0.9,3.9,3.2,3.3,4.7c-0.5,1.6-4.9-0.9-5.9-1.2c-4.4-1.5-9.2-2.1-13.8-2.2c-9-0.1-17.9,2.4-26.8,2.9 C380.9,240.2,380.9,238,380.3,234.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.7,234.6c0.2-1.7,1.2-4.4-0.1-5.8c-1.3-1.3-5.4-1.2-7.2-1.3c-5.1-0.5-10-0.7-15.1-0.5c-9.2,0.3-18.5,2.6-25.4,8.8 c-1,0.9-3.9,3.2-3.3,4.7c0.5,1.6,4.9-0.9,5.9-1.2c4.4-1.5,9.2-2.1,13.8-2.2c9-0.1,17.9,2.4,26.8,2.9 C333,240.2,333.1,238,333.7,234.6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyebrows1E);
export default __webpack_public_path__ + "static/media/eyebrows_1e.0d7c76cc3cf4b4084f7979459cd641cf.svg";
export { ForwardRef as ReactComponent };